import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Header from './components/Header/Header.vue';
import OrderDetails from './components/OrderDetails/OrderDetails.vue';
import OrderList from './components/OrderList/OrderList.vue';
import Login from './components/Login/Login.vue';
import Logout from './components/Logout/Logout.vue';
import AssociateDocument from './components/AssociateDocument/AssociateDocument.vue';
import AssociateEmailTemplate from './components/AssociateEmailTemplate/AssociateEmailTemplate.vue';
import EmailReport from './components/EmailReport/EmailReport.vue';
import DocumentReport from './components/DocumentReport/DocumentReport.vue';
import DocumentAddedReport from './components/DocumentAddedReport/DocumentAddedReport.vue';
import RmaList from './components/RmaList/RmaList.vue';

// new component added --sr--
import AddRma from './components/AddRma/AddRma.vue';
import RmaStatus from './components/RmaStatus/RmaStatus.vue';
import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children :[
        {
          path: '',
          name: 'order',
          component: OrderDetails,
        },
        // Rma Status field added --sr--
        {
          path: '/rma-status',
          name: 'status',
          component: RmaStatus,
        },
        {
          path: '/list',
          name: 'order-list',
          component: OrderList,
        },
        {
          path:'/login',
          name: 'login',
          component: Login,
        },
        {
          path:'/logout',
          name: 'logout',
          component: Logout,
        },
        {
          path:'/upload-document',
          name: 'upload-document',
          component: AssociateDocument,
          beforeEnter(to, from,next){
           let token = localStorage.getItem("token");
           if(token){
             next();
           } else{
             next({
               name: "login"
             })
           }
          }
        },
        {
          path:'/email-template',
          name: 'email-template',
          component: AssociateEmailTemplate,
          beforeEnter(to, from,next){
            let token = localStorage.getItem("token");
           if(token){
             next();
           } else{
             next({
               name: "login"
             })
           }
          }
        },
        {
          path: '/email-report',
          name: 'email-report',
          component: EmailReport,
          beforeEnter(to, from,next){
            let token = localStorage.getItem("token");
            let localAdmin = localStorage.getItem("isAdmin");
            let isAdmin = false;
            if(localAdmin == "true")
            {
              isAdmin = true;
            }
           if(token && isAdmin){
             next();
           }else if(token && isAdmin === false){
            next({
              name: "email-template"
            })
           }
            else{
             next({
               name: "login"
             })
           }
          }
        },
        {
          path: '/document-report',
          name: 'document-report',
          component: DocumentReport,
          beforeEnter(to, from,next){
            let token = localStorage.getItem("token");
            let localAdmin = localStorage.getItem("isAdmin");
            let isAdmin = false;
            if(localAdmin == "true")
            {
              isAdmin = true;
            }
           if(token && isAdmin){
             next();
           }else if(token && isAdmin === false){
            next({
              name: "email-template"
            })
           } else{
             next({
               name: "login"
             })
           }
          }
        },{
          path: '/document-added-report',
          name: 'document-added-report',
          component: DocumentAddedReport,
          beforeEnter(to, from,next){
            let token = localStorage.getItem("token");
            let localAdmin = localStorage.getItem("isAdmin");
            let isAdmin = false;
            if(localAdmin == "true")
            {
              isAdmin = true;
            }
           if(token && isAdmin){
             next();
           }else if(token && isAdmin === false){
            next({
              name: "email-template"
            })
           } else{
             next({
               name: "login"
             })
           }
          }
        },
        {
          path: '/rma-list',
          name: 'rma-list',
          component: RmaList
        }        
      ]
    },
    {
      path: '/header',
      name: 'header',
      component: Header,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
